<template>
  <div class='menu-wrapper'>
    <template v-for="item in routes">

      <router-link v-if="!item.hidden&&item.noDropdown&&item.children.length>0" :to="item.path+'/'+item.children[0].path">
        <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
          <icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg><span>{{item.children[0].name}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu :index="item.name" v-if="!item.noDropdown&&!item.hidden">
        <template slot="title">
          <icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg><span>{{item.name}}</span>
        </template>
        <template v-for="child in item.children" v-if='!child.hidden'>

          <el-submenu index="item.path+'/'+child.path" v-if='child.children&&child.children.length>0'>
            
              <template slot="title">
                <router-link  :to="item.path+'/'+child.path">
                  <el-menu-item style="padding-left:0px " :index="item.path+'/'+child.path">
                    <icon-svg v-if='child.icon' :icon-class="child.icon"></icon-svg><span>{{child.name}}</span>
                  </el-menu-item>
                </router-link>
              </template>
              <template v-for="_child in child.children" v-if='!_child.hidden'>
              <router-link  :to="item.path+'/'+child.path+'/'+_child.path">
                <el-menu-item :index="item.path+'/'+child.path+'/'+_child.path">
                  <icon-svg v-if='_child.icon' :icon-class="_child.icon"></icon-svg><span>{{_child.name}}</span>
                </el-menu-item>
              </router-link>
            </template>

          </el-submenu>

          <!-- <sidebar-item class='nest-menu' v-if='child.children&&child.children.length>0' :routes='[child]'>asd </sidebar-item> -->
          <router-link v-else :to="item.path+'/'+child.path">
            <el-menu-item :index="item.path+'/'+child.path">
              <icon-svg v-if='child.icon' :icon-class="child.icon"></icon-svg><span>{{child.name}}</span>
            </el-menu-item>
          </router-link>
        </template>

      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'vSidebarItem',
  props: {
    routes: {
      type: Array
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/public/sidebarItem.vue